/**
 * 课程学习抓拍记录
 */

import { post } from "@/util/request";
import download from "@/util/download";

/**
 * 分页获取课程学习抓拍记录
 * @param {*} data
 * @returns
 */
export const GetDataCourseSnapList = (data) => {
  return post("/api/app/course/getCourseChapterPhotographPageList", data, {});
};

/**
 * 导出课程学习抓拍记录
 * @param {*} data
 * @returns
 */
export const ExportDataCourseSnap = (data) => {
  let defaluturl = `/api/app/course/exportExcelFile`;
  let fileName = "课程学习抓拍记录";
  return download(fileName, defaluturl, data);
};
